import get from 'lodash/get';
import {
  FETCH_SHIPMENT_TYPE_DETAILS,
  FETCH_SHIPMENT_TYPE_DETAILS_FAILURE,
  FETCH_SHIPMENT_TYPE_DETAILS_SUCCESS,
  FETCH_SHIPMENTS,
  FETCH_SHIPMENTS_FAILURE,
  FETCH_SHIPMENTS_SUCCESS,
} from './types';

const initialState = {
  isShipmentTypeLoading: false,
  isShipmentsListLoading: false,
  shipmentData: [], // shipment types (from /shipment-type) for modal
  shipmentListData: [], // shipments list (from /shipments) for main table
  shipmentTypesLoading: 0,
};

const ShipmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHIPMENT_TYPE_DETAILS: {
      return {
        ...state,
        isShipmentTypeLoading: true,
      };
    }

    case FETCH_SHIPMENT_TYPE_DETAILS_SUCCESS: {
      const resData = get(action, 'response', {});
      const rows = Array.isArray(get(resData, 'rows')) ? resData.rows : [];
      rows.forEach((item, i) => {
        item.sno = i + 1;
      });
      return {
        ...state,
        shipmentData: rows,
        shipmentTypesLoading: get(resData, 'count', rows.length),
        isShipmentTypeLoading: false,
      };
    }

    case FETCH_SHIPMENT_TYPE_DETAILS_FAILURE: {
      return {
        ...state,
        isShipmentTypeLoading: false,
      };
    }

    case FETCH_SHIPMENTS: {
      return {
        ...state,
        isShipmentsListLoading: true,
      };
    }

    case FETCH_SHIPMENTS_SUCCESS: {
      const resData = get(action, 'response', {});
      const rows = Array.isArray(get(resData, 'rows')) ? resData.rows : [];
      rows.forEach((item, i) => {
        item.sno = i + 1;
      });
      return {
        ...state,
        shipmentListData: rows,
        isShipmentsListLoading: false,
      };
    }

    case FETCH_SHIPMENTS_FAILURE: {
      return {
        ...state,
        isShipmentsListLoading: false,
      };
    }

    default: {
      return state;
    }
  }
};

export default ShipmentReducer;
